module.exports = __webpack_public_path__ + "fonts/Amaranth-Bold.25c5e92e.otf";